import React from "react";
import {
  Box,
  Flex,
  Image,
  Heading,
  Text,
  Link,
  Divider,
  useTheme,
} from "@chakra-ui/core";
import DefaultLayout from "../../components/layouts/DefaultLayout";
import Breadcrumbs from "../../components/Breadcrumbs";
import PageHeading from "../../components/dashboard/Heading";
import PrimaryButton from "../../components/buttons/PrimaryButton";
import Clock from "../../components/icons/Clock";

const Resources = () => {
  const theme = useTheme();
  return (
    <DefaultLayout>
      <Flex
        direction="column"
        px="20px"
        py="48px"
        mx="auto"
        maxWidth="1240px"
        w="100%"
      >
        <Breadcrumbs breadcrumbs={["Orchid", "Resources"]} />
        <PageHeading>Resources</PageHeading>
        <Flex direction={["column", "column", "row"]} alignItems="flex-start">
          <Box
            maxWidth="100%"
            flexShrink="0"
            bg="#BBC9DC"
            borderRadius="8px"
            m={["0 auto 24px auto", "0 auto 24px auto", "0 64px 0 0"]}
          >
            <Image
              src="/images/resources/mother-child.png"
              alt="mother with baby"
              htmlWidth="400px"
              htmlHeight="228px"
              px="40px"
            />
          </Box>
          <Flex direction="column">
            <Heading
              fontSize="32px"
              fontWeight="300"
              color="orchidBlue500"
              mb="32px"
            >
              What you’ll learn from your report
            </Heading>
            <Text
              fontSize="18px"
              color="orchidGrey700"
              lineHeight="32px"
              flex="1"
              mb="32px"
            >
              The purpose of your report is to find out if your future child
              will have a genetic predisposition to any of the conditions we
              test for.
            </Text>
            <Flex direction="row" alignItems="center">
              <Link href="/resources/what-you-will-learn-from-your-report">
                <PrimaryButton p="16px 57px">Open</PrimaryButton>
              </Link>
              <Text fontSize="18px" color="orchidGrey600" ml="44px">
                <Text
                  position="relative"
                  top="5px"
                  display="inline-block"
                  mr="10px"
                >
                  <Clock
                    strokeColor={theme.colors.orchidGrey600}
                    height="24px"
                  />
                </Text>
                5 min read
              </Text>
            </Flex>
          </Flex>
        </Flex>
        <Divider my="48px" />
        <Flex direction={["column", "column", "row"]} alignItems="flex-start">
          <Box
            maxWidth="100%"
            flexShrink="0"
            m={["0 auto 24px auto", "0 auto 24px auto", "0 64px 0 0"]}
          >
            <Image
              src="/images/resources/ivf.png"
              alt="mother with baby"
              htmlWidth="400px"
              htmlHeight="228px"
              borderRadius="8px"
            />
          </Box>
          <Flex direction="column">
            <Heading
              fontSize="32px"
              fontWeight="300"
              color="orchidBlue500"
              mb="32px"
            >
              Embryo screening guide
            </Heading>
            <Text
              fontSize="18px"
              color="orchidGrey700"
              lineHeight="32px"
              flex="1"
              mb="32px"
            >
              In this guide, we’ll cover what embryo screening for common
              conditions can potentially do.
            </Text>
            <Flex direction="row" alignItems="center">
              <Link href="/resources/embryo-screening-guide">
                <PrimaryButton p="16px 57px">Open</PrimaryButton>
              </Link>
              <Text fontSize="18px" color="orchidGrey600" ml="44px">
                <Text
                  position="relative"
                  top="5px"
                  display="inline-block"
                  mr="10px"
                >
                  <Clock
                    strokeColor={theme.colors.orchidGrey600}
                    height="24px"
                  />
                </Text>
                8 min read
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </DefaultLayout>
  );
};

Resources.propTypes = {};

export default Resources;
